module.exports = __webpack_public_path__ + "static/img/login-logo.8aec937.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/login-logo.png
// module id = gCnq
// module chunks = 1